import script from "./IconFavorite.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconFavorite.vue?vue&type=script&setup=true&lang=ts"

import "./IconFavorite.vue?vue&type=style&index=0&id=20b45ab8&lang=scss"

const __exports__ = script;

export default __exports__